var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15653_7168)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_15653_7168)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 0.818359H25.8823V17.182H1.05469V0.818359Z",
  fill: "#CC0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.07422 2.17871H25.863V3.4878H1.07422V2.17871ZM1.07422 4.86166H25.863V6.17076H1.07422V4.86166ZM1.07422 7.54803H25.863V8.85712H1.07422V7.54803Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.05469 0.835449H13.4685V10.3809H1.05469V0.835449Z",
  fill: "#000066"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.10484 3.33427L9.3376 4.72177L10.2298 3.56268L9.74881 4.89904L11.126 4.18995L10.0359 5.21268L11.6264 5.10359L10.1406 5.60813L11.6264 6.11268L10.0359 6.00359L11.126 7.02632L9.74881 6.31722L10.226 7.657L9.33372 6.4945L9.10096 7.882L8.87208 6.4945L7.97984 7.65359L8.46087 6.31722L7.08372 7.02632L8.16993 6.00359L6.57941 6.11268L8.06906 5.60813L6.58329 5.10359L8.1738 5.21268L7.08372 4.18995L8.46087 4.89904L7.97984 3.55927L8.87208 4.72177L9.10484 3.33427ZM7.81303 3.39222C7.39312 3.22865 6.93337 3.15982 6.47551 3.19198C6.01765 3.22414 5.57618 3.35627 5.19117 3.57638C4.80616 3.7965 4.48979 4.09762 4.27079 4.45243C4.05179 4.80724 3.93708 5.20449 3.93708 5.60813C3.93708 6.01178 4.05179 6.40903 4.27079 6.76384C4.48979 7.11864 4.80616 7.41977 5.19117 7.63988C5.57618 7.86 6.01765 7.99213 6.47551 8.02429C6.93337 8.05645 7.39312 7.98762 7.81303 7.82404C7.34927 8.11645 6.80274 8.2908 6.23352 8.32793C5.66431 8.36505 5.09448 8.2635 4.58668 8.03446C4.07889 7.80541 3.65281 7.45774 3.35531 7.02967C3.0578 6.6016 2.90039 6.10973 2.90039 5.60813C2.90039 5.10654 3.0578 4.61466 3.35531 4.1866C3.65281 3.75853 4.07889 3.41086 4.58668 3.18181C5.09448 2.95276 5.66431 2.85122 6.23352 2.88834C6.80274 2.92546 7.34927 3.09982 7.81303 3.39222Z",
  fill: "#FFCC00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.07408 10.2344H25.8629V11.5435H1.07408V10.2344ZM1.07408 12.9003H25.8629V14.2094H1.07408V12.9003ZM1.05469 15.873H25.8435V17.1821H1.05469V15.873Z",
  fill: "white"
})));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 0.96875,
  y: 0.5,
  width: 25,
  height: 17,
  rx: 1.5,
  stroke: "#E0E4E8"
});
var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15653_7168"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1.46875,
  y: 1,
  width: 24,
  height: 16,
  rx: 1,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_15653_7168"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24.8276,
  height: 16.3636,
  fill: "white",
  transform: "translate(1.05469 0.818359)"
})));
function SvgMs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMs);
export default __webpack_public_path__ + "static/media/ms.d7b32a0c.svg";
export { ForwardRef as ReactComponent };